export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticModal.vue?vue&type=template&id=524f14eb"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-modal/VuesticModal.vue?vue&type=template&id=524f14eb
// module id = woCd
// module chunks = 41